export interface LoadingSpinnerProps {
    /** Tailwind CSS supported classname */
    className?: string;
}

// TODO:This will be moved to torque-ui once I figured out how to make images work in consuming app from torque
export function LoadingSpinner({ className }: LoadingSpinnerProps) {
    return (
        // eslint-disable-next-line @next/next/no-img-element -- copying as is from packages/ui for now
        <img
            className={className || "relative top-[35vh] m-auto w-14"}
            src="/assets/gif/loading-spinner.gif"
            alt="loading-spinner-gif"
        />
    );
}
